module.exports = __webpack_public_path__ + "img/REWARD01.d80485e7.png";